<template>
    <div class="stake-menu-component" :class="mode == 'dark' ? 'dark' : 'light'">
        <div class="uk-section uk-flex uk-flex-middle uk-flex-center">
            <div class="uk-card uk-card-default">
                <div class="uk-card-header uk-flex uk-flex-column uk-flex-middle">
                    <img :src="stakeCard.icon" alt="Logo of staked asset">
                    <h1 class="uk-text-center uk-margin-remove-top">{{ stakeCard.title }}</h1>
                    <div id="apy" class="uk-flex uk-flex-center uk-flex-middle">
                        <h3 class="uk-text-center uk-margin-right">APY: {{ stakeCard.APY }}%</h3>
                        <div class="uk-flex uk-flex-column uk-flex-center">
                            <h3
                                v-for="(link, index) in stakeCard.links" :key="link">
                                <a :href="link">{{ index }}<fa-icon class="uk-margin-small-left" icon="external-link-alt" size="sm"></fa-icon></a>
                            </h3>
                        </div>
                    </div>
                    <div id="stats" class="uk-flex uk-flex-center uk-flex-middle uk-margin-top">
                        <p class="uk-margin-remove-top uk-text-center">Total {{ stakeCard.earn }} Earned: 0.00000</p>
                        <p class="uk-margin-remove-top uk-text-center">Your unstaked {{ stakeCard.deposit }}: 0</p>
                        <p class="uk-margin-remove-top uk-text-center">Your staked {{ stakeCard.deposit }}: 0</p>
                    </div>
                </div>
                <div class="uk-card-body uk-flex uk-flex-column uk-flex-middle">
                    <input type="number" class="uk-input" placeholder="Amount">
                    <div id="button-array" class="uk-margin-small-top uk-flex uk-flex-around">
                        <button id="stake-button" class="uk-button">Stake</button>
                        <button class="uk-button">Claim Rewards</button>
                        <button class="uk-button">Unstake &amp; Claim</button>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
import {stakes} from "@/utils/Stakes";

export default {
    name: "StakeMenu",
    props: {
        mode: String
    },
    computed: {
        stakeCard: function() {
            return stakes[this.$route.params.id - 1];
        }
    }
}
</script>

<style lang="less" scoped>
    @import "../../dark-components/stake-menu.less";

    .uk-card {
        width: 75%;

        .uk-card-header {
            img {
                width: 128px;
            }

            h1 {
                color: @brand-color;
                font-family: 'Lato';
                .fluid-font(1.5, 20, 320, 3840);
                font-weight: 700;
            }

            h3 {
                font-family: 'Lato';
                font-weight: 700;
                .fluid-font(1.2, 15, 320, 3840);
                width: fit-content;
                margin: 0;

                a {
                    color: @link-color;
                }
            }

            p {
                color: @text-color;
                font-family: 'Lato';
                .fluid-font(1, 10, 320, 3840);
                margin-right: 3em;
            }
        }

        .uk-card-body {
            input {
                font-family: 'Lato';
                font-weight: 700;
                .fluid-font(1, 10, 320, 3840);
                color: @text-color;
                border: 2px @brand-color solid;
                border-radius: .2em;
                width: 75%;
            }

            #button-array {
                width: 75%;
            }

            button {
                font-family: 'Lato';
                font-weight: 700;
                .fluid-font(1, 5,  320, 3840);
                color: @brand-color;
                background-color: transparent;
                border: 2px @brand-color solid;
                border-radius: .2em;
            }

            button:hover {
                box-shadow: 5px 3px 0 @brand-color;
            }

            #stake-button {
                color: white;
                background-color: @brand-color;
            }
        }
    }

    @media only screen and(max-width: 640px) {
        #button-array {
            flex-direction: column;

            button {
                margin-bottom: .5em !important;
            }
        }

        #stats {
            flex-direction: column;

            p {
                margin-right: 0;
            }
        }

        #apy {
            flex-direction: column;
        }
    }
</style>